module.exports = __webpack_public_path__ + "img/meetingsclient5.210d3521.png";